import area from "./area"
import genericSearchLayout from "./genericSearchLayout"
import identifyOverlay from "./identifyOverlay"
import imageViewOverlay from "./imageViewOverlay"
import initiateApp from "./initiateApp"
import issue from "./issue"
import issueCreateOverlay from "./issueCreateOverlay"
import item from "./item"
import itemCreateOverlay from "./itemCreateOverlay"
import layout from "./layout"
import loginScreen from "./loginScreen"
import model from "./model"
import modelClassOverlay from "./modelClassOverlay"
import performedWork from "./performedWork"
import toDo from "./toDo"
import userSettings from "./userSettings"
import workOrder from "./workOrder"
import workspace from "./workspace"
import zone from "./zone"

export default {
  area,
  genericSearchLayout,
  identifyOverlay,
  initiateApp,
  issue,
  issueCreateOverlay,
  item,
  itemCreateOverlay,
  layout,
  loginScreen,
  model,
  modelClassOverlay,
  performedWork,
  toDo,
  userSettings,
  workOrder,
  workspace,
  zone,
  imageViewOverlay,
}
